import React from "react";

const NODES = [
  [80, 120], [260, 120], [260, 300], [460, 300], [460, 80], [640, 80],
  [140, 460], [340, 460], [340, 620], [560, 620], [700, 440], [120, 700],
];

export const TechWatermark = () => (
  <div className="tech-wm pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true" data-testid="tech-watermark">
    <svg className="h-full w-full" viewBox="0 0 800 800" preserveAspectRatio="xMidYMid slice">
      <defs>
        <pattern id="twm-grid" width="40" height="40" patternUnits="userSpaceOnUse">
          <circle cx="1" cy="1" r="1" fill="#93c5fd" opacity="0.18" />
        </pattern>
      </defs>
      <rect width="800" height="800" fill="url(#twm-grid)" />
      <g fill="none" stroke="#60a5fa" strokeWidth="1.4" opacity="0.22" strokeLinecap="round" strokeLinejoin="round">
        <path d="M0 120 H260 V300 H460 V80 H800" />
        <path d="M0 460 H340 V620 H560 L700 440 H800" />
        <path d="M120 800 V700 H40" />
        <path d="M640 0 V80" />
        <path d="M560 620 V800" />
      </g>
      <path className="tech-wm-flow" d="M0 120 H260 V300 H460 V80 H800" fill="none" stroke="#93c5fd" strokeWidth="2" opacity="0.6" />
      <path className="tech-wm-flow tech-wm-flow2" d="M0 460 H340 V620 H560 L700 440 H800" fill="none" stroke="#93c5fd" strokeWidth="2" opacity="0.6" />
      {NODES.map(([x, y], i) => (
        <g key={i}>
          <circle cx={x} cy={y} r="4" fill="#0b1530" stroke="#60a5fa" strokeWidth="1.4" opacity="0.5" />
          <circle className="tech-wm-pulse" cx={x} cy={y} r="4" fill="#60a5fa" style={{ animationDelay: `${(i % 6) * 0.7}s` }} />
        </g>
      ))}
    </svg>
    <div className="absolute inset-0 flex items-center justify-center">
      <img src="/logo-uaicard.png" alt="" className="tech-wm-logo w-[78vw] max-w-[620px]" draggable={false} />
    </div>
  </div>
);
